import { RootState } from '../../root'
import { AsyncTaskConfig } from './consts'
import { asyncApi } from './endpoints'
import { CheckAsyncTaskStatusArg } from './types'

export const selectInitiator = (state: RootState) => state.asyncTasks.initiator

export const selectBody = (endpoint: keyof typeof AsyncTaskConfig) => (state: RootState) =>
  state.asyncTasks.config[endpoint]?.body

export const selectMethod = (endpoint: keyof typeof AsyncTaskConfig) => (state: RootState) =>
  state.asyncTasks.config[endpoint]?.method

export const selectCachedData = (endpoint: keyof typeof AsyncTaskConfig) => (state: RootState) =>
  state.asyncTasks[endpoint]

export const makeSelectTaskStatusMeta =
  (asyncTask: keyof typeof AsyncTaskConfig) => (state: RootState) =>
    asyncApi.endpoints.startAsyncTask.select(asyncTask)(state)

export const makeSelectTaskStatus = (arg: CheckAsyncTaskStatusArg) => (state: RootState) =>
  asyncApi.endpoints.checkAsyncStatus.select(arg)(state)
